import React, { useEffect, useState } from 'react'
import { Box, Modal } from '@mui/material'
import classNames from 'classnames/bind'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'

import styles from './PopupInputPhone.module.css'
import { REGEX_NOT_NUMBER } from '~/constants/regex'
import STORAGE_KEYS from '~/constants/localStorage'
import { saveDataRestaurant, selectRestaurant } from '~/redux/restaurantSlice'
import { MERCHANT_TYPE } from '~/constants'
import { selectPopupTopPage } from '~/redux/popupTopPageSlice'
import { foodCourtPartners } from '~/constants/foodCourt'
import { updatePhoneNumberApi } from '~/apis/foodCourt'

const cx = classNames.bind(styles)

const MIN_LENGTH_INPUT = 9
const MAX_LENGTH_INPUT = 15

// Popup dùng chung ở nhiều màn
const PopupInputPhone = () => {
  const dispatch = useDispatch()
  const { open } = useSelector(selectPopupTopPage)
  const { merchant_type, food_court_partner, phone, food_court_id } = useSelector(selectRestaurant) // Thông tin nhà hàng
  const isRestaurantType = merchant_type === MERCHANT_TYPE.RESTAURANT
  const [visible, setVisible] = useState(false)

  const { t, i18n } = useTranslation()
  const [enteredPhone, setEnteredPhone] = useState('')
  const isDisabledInput = !enteredPhone.trim()
  const [errorMessage, setErrorMessage] = useState([])

  useEffect(() => {
    // Xử lý logic mở popup nhập phone user
    const local = localStorage.getItem(STORAGE_KEYS.LOCALE)
    if (!local) return

    if (
      isRestaurantType &&
      food_court_id &&
      !phone &&
      food_court_partner === foodCourtPartners.aeon_mall
    ) {
      setVisible(true)
    }
  }, [isRestaurantType, food_court_id, i18n.language, open, phone, food_court_partner])

  const inputChangePhoneHandler = (e) => {
    const { value } = e.target
    const realValue = value.replace(REGEX_NOT_NUMBER, '')
    setEnteredPhone(realValue)
    setErrorMessage([])
  }

  const renderInputPhone = () => {
    return (
      <Box>
        <input
          maxLength={MAX_LENGTH_INPUT}
          autoComplete="off"
          type="text"
          inputMode="numeric"
          placeholder={t('placeholder.your_phone')}
          value={enteredPhone}
          name="name"
          className={cx('input')}
          onChange={inputChangePhoneHandler}
        />
      </Box>
    )
  }

  // Hàm xử lý confirm. Cập nhật thông tin số điện thoại
  const handleConfirm = async () => {
    const phoneNumber = enteredPhone.trim()
    const lengthOfPhone = phoneNumber.length
    if (lengthOfPhone >= MIN_LENGTH_INPUT && lengthOfPhone <= MAX_LENGTH_INPUT) {
      const { isSuccess } = await updatePhoneNumberApi(phoneNumber)
      if (isSuccess) {
        setVisible(false)
        dispatch(
          saveDataRestaurant({
            phone: phoneNumber,
          }),
        )
      } else {
        setErrorMessage(['errors.server_error'])
      }
    } else {
      setErrorMessage([
        'errors.min_max_phone_number',
        { min: MIN_LENGTH_INPUT, max: MAX_LENGTH_INPUT },
      ])
    }
  }

  const renderButtonConfirm = () => {
    return (
      <button
        onClick={handleConfirm}
        className={cx('btn_confirm', {
          disabled: isDisabledInput,
        })}>
        {t('actions.confirm')}
      </button>
    )
  }

  const renderErrorMessage = () => {
    let error = ''

    if (errorMessage.length > 0) error = t(...errorMessage)

    return (
      <Box fontSize="1.3rem" color="red" mt="5px" minHeight="25px">
        {error}
      </Box>
    )
  }

  if (!visible) return null

  return (
    <Modal open={true}>
      <Box className={cx('wrapper')}>
        {/* Box toàn text */}
        <Box>
          <Box className={cx('title')}>{t('titles.input_a_phone')}</Box>
          <Box className={cx('question')}>{t('titles.why_we_need_it')}</Box>
          <Box className={cx('desc')}>{t('descriptions.input_a_phone')}</Box>
        </Box>

        {/* Input, Button */}
        <Box>
          {renderInputPhone()}
          {renderErrorMessage()}
          {renderButtonConfirm()}
        </Box>
      </Box>
    </Modal>
  )
}

export default React.memo(PopupInputPhone)
